import {
  META_DATA_LOADED,
  SUMMARY_DASHBOARD_SET_PAGINATION,
  SUMMARY_DASHBOARD_RESET_PAGINATION,
  SUMMARY_DASHBOARD_UPDATE_DATA,
  SUMMARY_DASHBOARD_DISABLE_LOADING,
  SUMMARY_DASHBOARD_ENABLE_LOADING,
  SUMMARY_DASHBOARD_SET_FILTER,
 } from '../actions/constants';

const defaultState = {
  metaData: {},
  isLoading: false,
  pagination: {
    currentPageNumber:1,
    resultPerPage: 10,
    nextOrPrev:'first',
    isNextPresent: false,
  },
  appliedFilters: {
    customerList: null,
  },
  tableData: [],
  tableColumns: [],
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case META_DATA_LOADED: {
      return {
        ...state,
        metaData: action.data,
      };
    }
    case SUMMARY_DASHBOARD_UPDATE_DATA: {
      return {
        ...state,
        tableColumns: action.data.headings,
        tableData: action.data.rawData.data,
        pagination : {
          ...state.pagination,
          lastConsignmentIdPrev: action.data.rawData ?
          action.data.rawData.lastItemIdPrev : 0,
          currentPageNumber: action.data.rawData ? action.data.rawData.currentPageNumber : 1,
          isNextPresent: action.data.rawData ? action.data.rawData.isNextPresent : false,
          lastConsignmentIdNext: action.data.rawData ?
          action.data.rawData.lastItemIdNext : 0,
          lastSortedColumnValuePrev: action.data.rawData ?
          action.data.rawData.lastSortedColumnValuePrev : 0,
          lastSortedColumnValueNext: action.data.rawData ?
          action.data.rawData.lastSortedColumnValueNext : 0,
        },
      };
    }
    case SUMMARY_DASHBOARD_SET_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case SUMMARY_DASHBOARD_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUMMARY_DASHBOARD_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case SUMMARY_DASHBOARD_RESET_PAGINATION: {
      return {
        ...state,
        pagination : defaultState.pagination,
      };
    }
    case SUMMARY_DASHBOARD_SET_PAGINATION: {
      return {
        ...state,
        pagination : {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    default: {
      return state;
    }
  }
}
